import { useCallback, useEffect, useState } from "react";
import { RefreshCw } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { api } from "@/lib/api";

const fmtWhen = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  return d.toLocaleDateString("en-AU", { day: "numeric", month: "short" }) + ", " +
    d.toLocaleTimeString("en-AU", { hour: "numeric", minute: "2-digit" });
};

/** "Last synced" indicator — shows when financial data was last imported.
 *  Live-updates via the global `fin-sync-updated` event (no page refresh). */
export const LastSyncedBadge = ({ compact = false, className = "" }) => {
  const [status, setStatus] = useState(null);

  const load = useCallback(() => {
    api.get("/financials/sync-status").then((r) => setStatus(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    load();
    window.addEventListener("fin-sync-updated", load);
    return () => window.removeEventListener("fin-sync-updated", load);
  }, [load]);

  if (!status?.synced) return null;

  return (
    <Badge
      variant="outline"
      className={`gap-1 font-normal text-muted-foreground ${className}`}
      title={`Last import: ${status.filename || "file"} · ${status.row_count} rows · by ${status.created_by || "—"}`}
      data-testid="last-synced-badge"
    >
      <RefreshCw className="h-3 w-3" />
      {compact ? fmtWhen(status.last_synced) : `Last synced ${fmtWhen(status.last_synced)}`}
    </Badge>
  );
};
